export enum BlockCoreButtonType {
  FILL = 'fill',
  OUTLINE = 'outline'
}
